// @ts-nocheck
import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';
import REGEX from '../../const/Regex';

export const getInitials = (name = '') =>
  name
    .split(REGEX.NAME_WORD_SPLIT)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

export const getAvatarColor = (name = '', avatarColors = []) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return avatarColors[Math.abs(hash) % avatarColors.length];
};

// Function to find username by user ID
export const findUsernameByUserId = (userId, usersList) => {
  if (!userId || !usersList || !Array.isArray(usersList)) {
    return null; // Return null for empty strings
  }

  // Find the user by matching the user ID with item's user_id property
  const user = usersList.find(
    (userItem) => String(userItem?.user_id) === String(userId)
  );

  return user?.username || user?.user || null;
};

// Function to find group name by group ID
export const findGroupNameByGroupId = (groupId, groupList) => {
  if (!groupId || !groupList || !Array.isArray(groupList)) {
    return null; // Return null for empty strings
  }

  // Find the group by matching the group ID with item's id property
  const group = groupList.find(
    (groupItem) => String(groupItem?.id) === String(groupId)
  );

  return group?.groupName || null;
};

export const getUniqueUsersList = (usersList) => {
  const uniqueUsers = {};

  return usersList?.filter((user) => {
    if (user?.is_grp) {
      return false;
    }
    if (!uniqueUsers[user?.user]) {
      uniqueUsers[user?.user] = true;
      return true;
    }
    return false;
  });
};

/**
 * Extract user options from model team response.
 * @param {object[]} modelTeam array of model team members
 * @returns {string[]} All unique users in the model team flattened
 */
export function extractUserOptionsFromModelTeam(modelTeam) {
  return uniq(
    flatten(
      modelTeam?.map((obj) => (obj?.is_grp ? obj?.group_member : obj?.user))
    )
  );
}
